import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Grid,
  CircularProgress,
  Tabs,
  Tab,
  Divider,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import TabPanel from "../../components/TabPanel";

import { useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";
import {
  GridComp12,
  GridComp4,
  GridComp6,
} from "../../components/GridComponents";

import { makeStyles } from "@mui/styles";
import QuoteItems from "./quote/items";
import QuoteShipping from "./quote/shipping";
import QuoteAvaTax from "./quote/ava-tax";
import QuoteEft from "./quote/eft";
import QuoteCustom from "./quote/custom";
import QuoteSystemInformation from "./quote/systemInformation";
import QuoteCommunication from "./quote/communication";
import QuoteRelationship from "./quote/relationship";
import QuoteAccounting from "./quote/accounting";
import QuoteBilling from "./quote/billing";
import QuoteRelatedRecords from "./quote/related-records";
import { getTransactionQuotesEstimateDetails } from "../../api/transaction-type";

const useStyles = makeStyles((theme) => ({
  spacedTabs: {
    "& .MuiTab-root": {
      marginRight: theme.spacing(2),
    },
  },
}));

export default function TransactionTypeQuote() {
  const classes = useStyles();
  const snackbar = useSnackbar();
  const params = useParams();
  const [rowData, setRowData] = useState([]);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const { data: user } = useSelector((state) => state.user);

  /*----------------Tabs-----------------*/
  const [tabIndex, setTabIndex] = useState(0);
  const [itemsum, setSum] = useState("");

  useEffect(() => {
    if (user.token) {
      getTransactionDocDetailTableData();
    }
  }, []);

  async function getTransactionDocDetailTableData(limit = 10, offset = 0) {
    setLoading(true);
    try {
      const { data } = await getTransactionQuotesEstimateDetails(user.token, {
        tranid: params.docNo,
        limit,
        offset,
      });
      setData(data.data);
      setRowData(data.data.details[0]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
    }
  }

  return loading ? (
    <>
      <Typography component="h4" fontWeight={500} className="pageTitle">
        Estimate
      </Typography>

      <Typography component="h5" style={{ marginBottom: "10px" }}>
        <span className="para-no">
          <strong>{rowData?.estimate_number}</strong> {rowData?.customer_name}
        </span>

        <Button
          className="blue-button"
          size="small"
          style={{ marginLeft: "10px" }}
        >
          EXPIRED
        </Button>
      </Typography>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" variant="contained" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Sales Information
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  ) : (
    <>
      {/* Primary Information */}
      <Typography component="h4" fontWeight={500} className="pageTitle">
        Estimate
      </Typography>

      <Typography component="h5" style={{ marginBottom: "10px" }}>
        <span className="para-no">
          <strong>{rowData?.estimate_number}</strong> {rowData?.customer_name}
        </span>

        <Button
          className="blue-button"
          size="small"
          style={{ marginLeft: "10px" }}
        >
          {rowData?.status}
        </Button>
      </Typography>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12} sm={6} md={8}>
              <Grid container className="mb-2">
                <GridComp6
                  title={"ESTIMATE#"}
                  data={rowData?.estimate_number}
                />
                <GridComp6 title={"DATE"} data={rowData?.date} />
                <GridComp6 title={"CUSTOMER"} data={rowData?.customer_name} />
                <GridComp6 title={"MEMO"} data={rowData?.memo} />
                <GridComp6 title={"PC/PROJECT"} data={rowData?.pc_project} />
                <GridComp6 title={"CATERING CUSTOMER NAME"} data={rowData?.catering_customer_name} />
                <GridComp6  />
                <GridComp6 title={"CATERING CUSTOMER-ADDRESS-BILLING"} data={rowData?.catering_customer_bill_address} />
                <GridComp6 title={"TITLE"} data={rowData?.title} />
                <GridComp6 title={"EXPIRES"} data={rowData?.expire_date} />
              </Grid>
            </Grid>

            {/* Summary Box */}
            <Grid item xs={12} sm={6} md={4}>
              <Box className="viewBox">
                <Box
                  className="headerItemsSB"
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  pb={2}
                >
                  <Typography
                    component="h5"
                    fontWeight={500}
                    className="pageHeading1"
                  >
                    Summary
                  </Typography>
                </Box>
                <Box className="viewDetilsBox1">
                  <Grid container>
                    <Grid item xs={12} sm={6} md={6} className="m-b-10">
                      <p className="tFormlabel">SUBTOTAL</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} className="m-b-10">
                      <p className="tFormtotal">{rowData?.amount}</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} className="m-b-10">
                      <p className="tFormlabel">DISCOUNT ITEM</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} className="m-b-10">
                      <p className="tFormtotal">{rowData?.discount_item}</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} className="m-b-10">
                      <p className="tFormlabel">TAX TOTAL</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} className="m-b-10">
                      <p className="tFormtotal">{rowData?.total_tax}</p>
                    </Grid>
                  </Grid>
                  <Divider />
                  <Grid container sx={{ mt: 1 }}>
                    <Grid item xs={12} sm={6} md={6} className="m-b-10">
                      <p className="tFormlabel">TOTAL</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} className="m-b-10">
                      <p className="tFormtotal">{data?.total}</p>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Sales Information
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12} sm={6} md={8}>
              <Grid container className="mb-2">
                <GridComp12 title={"SALES REP"} data={rowData?.sales_rep} />
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>

      {/*Classification*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          {/* {rowData?.map((d, i) => ( */}
          <Grid container className="mb-2">
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">SUBSIDIARY</p>
              <p className="tFormName">{rowData?.subsidiary}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">DEPARTMENT</p>
              <p className="tFormName">{rowData?.department}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">SERVICE LINE</p>
              <p className="tFormName">{rowData?.service_line}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">STATUS</p>
              <p className="tFormName">{rowData?.status}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">BILL-TO ENTITY/USE CODE</p>
              <p className="tFormName">{rowData?.bill_to_use_code}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">CUSTOMER ID</p>
              <p className="tFormName">{rowData?.customerid}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">PROBABILITY</p>
              <p className="tFormName">{rowData?.probability}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">INVOICE MESSAGING</p>
              <p className="tFormName">{rowData?.invoice_messaging}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">SEVICE PERIOD</p>
              <p className="tFormName">{rowData?.service_period}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel checkAndTextAlign">
                {rowData?.includeinforecast ===
                  "false" ||
                rowData?.includeinforecast ===
                  null ? (
                  <>
                    <FormGroup>
                      <FormControlLabel control={<Checkbox disabled/>} label="" />
                    </FormGroup>
                    INCLUDE IN FORECAST
                  </>
                ) : (
                  <>
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox checked disabled/>}
                        label=""
                      />
                    </FormGroup>
                    INCLUDE IN FORECAST
                  </>
                )}
              </p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel checkAndTextAlign">
                {rowData?.seller_imported_record === "false" ||
                rowData?.seller_imported_record === null ? (
                  <>
                    <FormGroup>
                      <FormControlLabel control={<Checkbox disabled/>} label="" />
                    </FormGroup>
                    IS SELLER IMPORTER OF RECORD
                  </>
                ) : (
                  <>
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox checked />}
                        label=""
                      />
                    </FormGroup>
                    IS SELLER IMPORTER OF RECORD
                  </>
                )}
              </p>
            </Grid>

            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">CUSTOM DUTY AND IMPORT FEES</p>
              <p className="tFormName">{rowData?.custom_duty_fee}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">LINKED CUSOTMER RECORD</p>
              <p className="tFormName">{rowData?.linked_customer_record}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">PROJECT ID</p>
              <p className="tFormName">{rowData?.projectid}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel checkAndTextAlign">
                {rowData?.exclude_from_ep_process ===
                  "false" ||
                rowData?.exclude_from_ep_process ===
                  null ? (
                  <>
                    <FormGroup>
                      <FormControlLabel control={<Checkbox disabled/>} label="" />
                    </FormGroup>
                    EXCLUDE FROM ELECTRONIC BANK PAYMENTS PROCESSING
                  </>
                ) : (
                  <>
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox checked disabled/>}
                        label=""
                      />
                    </FormGroup>
                    EXCLUDE FROM ELECTRONIC BANK PAYMENTS PROCESSING
                  </>
                )}
              </p>
              <p className="tFormlabel checkAndTextAlign">
                {rowData?.disable_tax_calculation ===
                  "false" ||
                rowData?.disable_tax_calculation ===
                  null ? (
                  <>
                    <FormGroup>
                      <FormControlLabel control={<Checkbox disabled/>} label="" />
                    </FormGroup>
                    DISABLE AVALARA TAX CALCULATION
                  </>
                ) : (
                  <>
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox checked />}
                        label=""
                      />
                    </FormGroup>
                    DISABLE AVALARA TAX CALCULATION
                  </>
                )}
              </p>
            </Grid>
            <Grid item xs={12} sm={6} md={6} className="m-b-10">
              <p className="tFormlabel">LOCATION</p>
              <p className="tFormName">{rowData?.location}</p>
            </Grid>
            <Grid item xs={12} sm={12} md={12} className="m-b-10">
              <p className="tFormlabel">SHIP-TO ENTITY/USE CODE</p>
              <p className="tFormName">{rowData?.ship_to_entity_use_code}</p>
            </Grid>
          </Grid>
          {/* ))} */}
        </Box>
      </Box>
      {/* Tabs */}
      <Box className="viewBox">
        <Tabs
          value={tabIndex}
          onChange={(e, nv) => {
            setTabIndex(nv);
          }}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          className={`${classes.spacedTabs} tabs-bkg`}
          // className="tabs-bkg"
        >
          <Tab label={`Items ${itemsum||"0.00"}`} />
          <Tab label="Shipping" />
          <Tab label="Billing" />
          <Tab label="Accounting" />
          <Tab label="Relationships" />
          <Tab label="Communication" />
          <Tab label="Related Records" />
          <Tab label="System Information" />
          <Tab label="Custom" />
          <Tab label="EFT" />
          <Tab label="AvaTax" />
        </Tabs>

        {/* Tab Panels */}
        <TabPanel value={tabIndex} index={0}>
          {tabIndex === 0 && <QuoteItems setSum={setSum} />}
        </TabPanel>
        <TabPanel value={tabIndex} index={1}>
          {tabIndex === 1 && <QuoteShipping />}
        </TabPanel>
        <TabPanel value={tabIndex} index={2}>
          {tabIndex === 2 && <QuoteBilling />}
        </TabPanel>
        <TabPanel value={tabIndex} index={3}>
          {tabIndex === 3 && <QuoteAccounting />}
        </TabPanel>
        <TabPanel value={tabIndex} index={4}>
          {tabIndex === 4 && <QuoteRelationship />}
        </TabPanel>
        <TabPanel value={tabIndex} index={5}>
          {tabIndex === 5 && <QuoteCommunication />}
        </TabPanel>
        <TabPanel value={tabIndex} index={6}>
          {tabIndex === 6 && <QuoteRelatedRecords />}
        </TabPanel>
        <TabPanel value={tabIndex} index={7}>
          {tabIndex === 7 && <QuoteSystemInformation />}
        </TabPanel>
        <TabPanel value={tabIndex} index={8}>
          {tabIndex === 8 && <QuoteCustom />}
        </TabPanel>
        <TabPanel value={tabIndex} index={9}>
          {tabIndex === 9 && <QuoteEft />}
        </TabPanel>
        <TabPanel value={tabIndex} index={10}>
          {tabIndex === 10 && <QuoteAvaTax />}
        </TabPanel>
      </Box>
    </>
  );
}
